(() => {
  if (window.lusupProductRestockOnlyReady) return;
  window.lusupProductRestockOnlyReady = true;

  const buttonGroupSelector = '.product-form__buttons';
  const addButtonSelector = '.product-form__submit';
  const notifyButtonSelector = '.notify-me-btn, .alertme-btn, #notifyMeButton';
  let updateFrame = 0;

  const updateButtonGroups = () => {
    document.querySelectorAll(buttonGroupSelector).forEach((group) => {
      const addButton = group.querySelector(addButtonSelector);
      const notifyButton = group.querySelector(notifyButtonSelector);
      const notifyStyle = notifyButton ? window.getComputedStyle(notifyButton) : null;
      const notifyVisible = Boolean(
        notifyButton &&
        notifyStyle?.display !== 'none' &&
        notifyStyle?.visibility !== 'hidden' &&
        notifyButton.getClientRects().length
      );
      const restockOnly = Boolean(addButton?.disabled && notifyVisible);

      if (group.classList.contains('product-form__buttons--restock-only') !== restockOnly) {
        group.classList.toggle('product-form__buttons--restock-only', restockOnly);
      }
    });
  };

  const scheduleUpdate = () => {
    window.cancelAnimationFrame(updateFrame);
    updateFrame = window.requestAnimationFrame(updateButtonGroups);
  };

  const initialize = () => {
    updateButtonGroups();

    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'disabled', 'style'],
    });

    document.addEventListener('change', scheduleUpdate);
    document.addEventListener('shopify:section:load', scheduleUpdate);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
